<template>
  <div :class="`m-portal m-portal-${routeType}-page`">
    <portal-nav-top></portal-nav-top>
    <div id="ljh-travel">
      <div class="container-fluid">
        <el-row :gutter="20">
          <el-col :span="6" class="left-menu-wrap">
            <portal-dest-nav></portal-dest-nav>
          </el-col>
          <el-col :span="18" class="content-page-wrap">
            <div class="content-page">
              <div class="navigation">
                <span>首页</span>
                <span>&nbsp;>&nbsp;</span>
                <span>文化旅游</span>
                <span>&nbsp;>&nbsp;</span>
                <span>景区景点</span>
              </div>
              <bs-list
                :filter="filter"
                :meta="{ module:'common-area',field:'destArea' }"
                :is-loading="true"
              >
                <template slot="data" slot-scope="slot">
                  <div class="head-select">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <div class="grid-content bg-purple">
                          <span class="address">地区选择:</span>
                          <ul>
                            <li
                              v-bind:class="{'selected': selectedAreaCode==''}"
                              v-on:click="selectArea({id:''})"
                            >
                              <a class="font-size">不限</a>
                            </li>
                            <li
                              v-for="(item,index) in slot.data"
                              :key="index"
                              v-bind:class="{'selected':    selectedAreaCode  == item.id}"
                              v-on:click="selectArea(item)"
                            >
                              <a class="font-size">{{item.name}}</a>
                            </li>
                          </ul>
                        </div>
                      </el-col>
                    </el-row>
                    <div style="margin-bottom: 10px;">
                      <span style="font-size:16px;">景区名称:</span>
                      <el-input v-model="input" placeholder="请输入内容" clearable></el-input>
                      <el-button type="primary" @click="search()">查询</el-button>
                    </div>
                  </div>
                </template>
              </bs-list>

              <div class="container">
                <el-row :gutter="20">
                  <bs-page
                    :filter="filter"
                    ref="refId"
                    :meta="{ module:'destinations', field:'spot' }"
                    content-class
                  >
                    <template slot="data" slot-scope="slot">
                      <el-col
                        :span="6"
                        v-for="item in slot.data"
                        :key="item.destId"
                        class="list-wrap"
                      >
                        <div
                          @click="handleDestDetail('destinations','spot',item)"
                          class="item"
                          style="cursor:pointer"
                        >
                          <div style="height:100px;width:160.5px;">
                            <img
                              :src="item.imgUrl||$app.nodata.img"
                              :alt="item.destName"
                              class="img-fluid"
                            />
                          </div>
                          <h5 class="title" v-text="item.destName"></h5>
                        </div>
                        <div class="bottom">&nbsp;</div>
                      </el-col>
                    </template>
                    <template slot="empty">
                      <div>
                        <img src="../../assets/portal/zwsj.png" style="width:100%;height:300px" />
                      </div>
                    </template>
                    <template slot="paging" slot-scope="slot">
                      <el-pagination
                        v-if="slot.data.totalCount>20"
                        background
                        style="float:clear; clear:both;margin:0 auto;text-align: center"
                        layout="prev, pager, next"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="filter.pageIndex"
                        :page-size="filter.pageSize"
                        :total="slot.data.totalCount"
                      ></el-pagination>
                    </template>
                  </bs-page>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import { debuglog } from "util";
require("../../styles/portal/travel.scss");
export default {
  data() {
    return {
      selectedAreaCode: "",
      input: "",
      routeType: "dest",
      filter: {
        pageIndex: 1,
        pageSize: 20,
        areaCode: "",
        destName: ""
      }
    };
  },
  computed: {
    // input: function() {
    //   debugger;
    //   var input = this.input;
    //   if (input) {
    //     console.log(input);
    //   }
    // }
  },
  components: {
    PortalFooter: () => import("./portal-footer"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalDestNav: () => import("./portal-dest-nav"),
    BsPage: () => import("../../components/bs-page"),
    BsList: () => import("../../components/bs-list")
  },
  methods: {
    selectArea: function(item) {
      this.selectedAreaCode = item.id;
      this.filter.areaCode = item.id;
      this.$refs["refId"].loadData();
      this.filter.pageIndex = 1;
    },
    search: function() {
      this.filter.destName = this.input;
      this.$refs["refId"].loadData();
      this.filter.pageIndex = 1;
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    },
    handleDestDetail(moudle, field, item) {
      // this.$router.push({
      //   path: `/portal/dest/detail/${moudle}/${field}_detail/${item.destId}`
      // });
      window.location.href = `/portal/dest/detail/${moudle}/${field}_detail/${item.destId}`;
    }
  },
  created() {
    this.$menuFn.setTitle("景区景点-朱子文化·综合信息服务平台");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-dest-page") {
        this.$menuFn.setTitle("景区景点-朱子文化·综合信息服务平台");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "portal"
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    },
    input(newVal, oldVal) {
      if (newVal) {
        this.filter.destName = newVal;
        this.$refs["refId"].loadData();
        this.filter.pageIndex = 1;
      } else {
        this.filter.destName = "";
        this.$refs["refId"].loadData();
        this.filter.pageIndex = 1;
      }
    }
  }
};
</script>
<style lange="scss" scoped>
.head-select {
  /* height: 110px; */
}
.address {
  float: left;
  font-size: 16px;
}
ul {
  list-style: none;
  margin-top: -25px;
  margin-left: 40px;
  display: inline-block;
}

li {
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  cursor: pointer;
  overflow: hidden;
  font-size: 16px;
  margin-right: 5px;
  margin: 5px;
}
ul li.selected {
  background-color: #ecb700;
  color: #fff;
}
ul li:hover {
  background-color: #ecb700;
  color: #fff;
}
ul li:active {
  background-color: #ecb700;
  color: #fff;
}
.font-size {
  font-size: 16px;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 60%;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 250px;
  margin-left: 20px;
}

.el-button--small {
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 20px;
}
</style>